import React, { useContext } from 'react';
import { PilotContext } from './pilot';

const usePilot = () => {
  return useContext(PilotContext);
};

export default usePilot;
